export default __webpack_public_path__ + "static/media/locker.d91db54b.svg";